import React, { useEffect, useState } from "react";
import { FolderInput, Loader2, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ChellyImportCard() {
  const [s, setS] = useState(null);
  const load = () => api.get("/chelly-import/state").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (s?.status !== "running") return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [s?.status]);
  const run = async () => {
    if (!window.confirm(`Importer les ${s?.chelly_clients} clients Chelly dans Dossiers ? Les clients déjà présents seront fusionnés (pas de doublon).`)) return;
    try { await api.post("/chelly-import/run"); toast.success("Import lancé"); setS((x) => ({ ...x, status: "running" })); setTimeout(load, 1500); }
    catch (e) { toast.error(e?.response?.data?.detail || "Import impossible"); }
  };
  if (!s) return null;
  const st = s.stats || {};
  const doneCount = (st.created || 0) + (st.merged || 0) + (st.skipped || 0) + (st.errors || 0);
  const running = s.status === "running";
  const finished = s.status === "done";
  return (
    <div className="mb-6 p-4 rounded-lg border border-teal-200 bg-teal-50/60 flex flex-wrap items-center gap-4" data-testid="chelly-import-card">
      <FolderInput className="w-5 h-5 text-teal-700" />
      <div className="flex-1 min-w-[240px]">
        <div className="text-sm font-semibold text-norea-text">Importer le backup dans Dossiers</div>
        <div className="text-xs text-norea-textMuted" data-testid="chelly-import-status">
          {running ? `Import en cours… ${doneCount} / ${s.total}` : finished
            ? `Terminé : ${st.created || 0} créés · ${st.merged || 0} fusionnés${st.errors ? ` · ${st.errors} erreurs` : ""} — ${s.imported_dossiers} dossiers portent l'étiquette « Import Chelly »`
            : `${s.chelly_clients} clients prêts à devenir des dossiers (étiquette « Import Chelly », sans IA)`}
        </div>
        {running && <div className="mt-2 h-1.5 rounded bg-white overflow-hidden"><div className="h-full bg-teal-600 transition-[width]" style={{ width: `${Math.round((doneCount / (s.total || 1)) * 100)}%` }} /></div>}
      </div>
      {finished ? (
        <Link to="/dossiers" className="btn-secondary text-sm" data-testid="chelly-import-open"><CheckCircle2 className="w-4 h-4 text-teal-700" /> Voir les dossiers</Link>
      ) : (
        <button onClick={run} disabled={running} className="btn-primary text-sm" data-testid="chelly-import-run">
          {running ? <Loader2 className="w-4 h-4 animate-spin" /> : <FolderInput className="w-4 h-4" />} {running ? "Import en cours…" : "Lancer l'import"}
        </button>
      )}
    </div>
  );
}
